module.exports = {"__schema":{"types":[{"kind":"INTERFACE","name":"Node","possibleTypes":[{"name":"Asset"},{"name":"AssetWithDescription"},{"name":"ComponentSection"},{"name":"Component"},{"name":"Topic"},{"name":"Vehicle"},{"name":"CustomerBenefit"},{"name":"CustomerBenefitSection"},{"name":"Hotspot"},{"name":"TopicSection"},{"name":"TopicCluster"},{"name":"TopicClusterHotspot"},{"name":"EntryScreenItem"},{"name":"EntryScreenSubItem"},{"name":"News"},{"name":"GeneralTranslation"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 951
// module chunks = 0